import { Link } from "react-router-dom";
import NewsCarousel from "./NewsCarousel";
import TipsCarousel from "./TipsCarousel";
import { ChartIcon, HeartIcon, TagIcon } from "./Icons";
import Logo from './Logo';

export default function Home () {
    return (
        <>
            <section className="hero">
                <div className="heroCopy">
                    <span className="heroEyebrow">D.C. deals delivered</span>
                    <h1 className="heroTitle">We dig through Amazon so you don't have to.</h1>
                    <p className="heroSub">
                        Every deal here is checked against what the product usually sells for before it goes up.
                        No fake markdowns, no "was $999" nonsense.
                    </p>
                    <div className="heroActions">
                        <Link to="/deals" className="btn btn-primary btn-lg">Shop our latest finds</Link>
                        <Link to="/tips" className="btn btn-ghost btn-lg">Read the tips</Link>
                    </div>
                </div>
                {/* Brand-only art: Amazon Marks may appear only beside a Special Link to a product, unaltered. */}
                <div className="heroArt" aria-hidden="true">
                    <div className="tagStack">
                        <div className="priceTag priceTagBack" />
                        <div className="tagSwing">
                            <span className="tagString" />
                            <div className="priceTag">
                                <Logo className="priceTagLogo" />
                                <p className="tagScrawl"><s>full price</s><span>not here</span></p>
                                <span className="tagBarcode" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section">
                <div className="sectionHeader">
                    <h2 className="sectionTitle">News</h2>
                    <Link className="sectionLink" to="/news">All news</Link>
                </div>
                <NewsCarousel />
            </section>

            <section className="section">
                <div className="sectionHeader">
                    <h2 className="sectionTitle">Tips from our team</h2>
                    <Link className="sectionLink" to="/tips">All tips</Link>
                </div>
                <TipsCarousel />
            </section>

            <section className="section">
                <div className="mission">
                    <h2 className="missionTitle">Empowering Thrifty Shoppers and E-commerce Businesses Alike</h2>
                    <p>
                    At DC Thrift Shop, we're revolutionizing the thrift shopping experience through cutting-edge technology. Our innovative platform streamlines inventory sourcing, ensuring access to the best deals on the market.
                    </p>
                </div>
                <div className="infoGrid">
                    <div className="infoCard">
                        <TagIcon className="infoIcon" />
                        <h3>For Shoppers</h3>
                        <p>
                            Discover exceptional bargains on Amazon storefront products, carefully curated just for you.
                            Explore our constantly updated selection of hidden gems and must-haves.
                            Enjoy a seamless, user-friendly shopping experience.
                        </p>
                    </div>
                    <div className="infoCard infoCardAccent">
                        <HeartIcon className="infoIcon" />
                        <h3>Support Our Mission</h3>
                        <p>
                            If you find a great deal through our platform, we kindly ask that you use our affiliate links to make your purchase as we receive a small commission on purchased products.
                        </p>
                    </div>
                    <div className="infoCard">
                        <ChartIcon className="infoIcon" />
                        <h3>For E-commerce Businesses</h3>
                        <p>
                            Partner with us to optimize your product offerings and boost customer satisfaction.
                            Leverage our expertise in retailer APIs to streamline inventory sourcing.
                            Gain insights into market trends and customer preferences.
                        </p>
                    </div>
                </div>
            </section>
        </>
    );
  };
